// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2655":"75db7ebc8d86b214","7375":"3fd02c25bee5ff4e"}[chunkId] + ".css";
};